export const groupTypeLabel = {
  residential: 'Residential',
  association: 'Association',
  custom_campaign: 'Affinity',
  business: 'Business',
  business_product: 'Product'
};
